import { Icons } from '@commenda/kakashi';
import { SummaryFieldKS } from '../../common/SummaryFieldKS';

type SummaryEntityNamesProps = {
  hideActionButtons?: boolean;
  setActiveStep: (itemIndex: number) => void;
  requestData: {
    companyLegalName: string;
    companyLegalName2: string;
    companyLegalName3: string;
    translatedCorporationName: string;
    translatedCompanyLegalName2: string;
    translatedCompanyLegalName3: string;
  };
};
export const SummaryEntityNames = ({
  hideActionButtons = false,
  setActiveStep,
  requestData,
}: SummaryEntityNamesProps) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h4 className="body-16-bold text-text-primary">Entity names</h4>
        {hideActionButtons ? null : (
          <Icons.Edit01
            className="cursor-pointer"
            onClick={() => setActiveStep(1)}
          />
        )}
      </div>
      <div className="flex flex-col gap-3 bg-bg-disabled-subtle rounded-sm">
        <div className="flex flex-col gap-2 p-6">
          {requestData?.companyLegalName ? (
            <SummaryFieldKS
              heading="Entity name 1"
              value={requestData.companyLegalName}
            />
          ) : null}
          {requestData?.companyLegalName2 ? (
            <SummaryFieldKS
              heading="Entity name 2"
              value={requestData.companyLegalName2}
            />
          ) : null}

          {requestData?.companyLegalName3 ? (
            <SummaryFieldKS
              heading="Entity name 3"
              value={requestData.companyLegalName3}
            />
          ) : null}
          {requestData?.translatedCorporationName ? (
            <SummaryFieldKS
              heading="Entity name 1 (Arabic)"
              value={requestData.translatedCorporationName}
            />
          ) : null}
          {requestData?.translatedCompanyLegalName2 ? (
            <SummaryFieldKS
              heading="Entity name 2 (Arabic)"
              value={requestData.translatedCompanyLegalName2}
            />
          ) : null}
          {requestData?.translatedCompanyLegalName3 ? (
            <SummaryFieldKS
              heading="Entity name 3 (Arabic)"
              value={requestData.translatedCompanyLegalName3}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
